import React, { useEffect } from "react";
import "./Clients.css";
import AOS from "aos";
import "aos/dist/aos.css";

// List of clients with dummy logos
const clients = [
  { name: "Delval Flow and Control Pvt. Ltd.", logo: "/images/client-placeholder.png" },
  { name: "Sulzer India Pumps Pvt. Ltd.", logo: "/images/client-placeholder.png" },
  { name: "RK Control & Instruments Pvt. Ltd.", logo: "/images/client-placeholder.png" },
  { name: "Kirloskar Ebara Pvt. Ltd.", logo: "/images/client-placeholder.png" },
  { name: "TMP Spa Termomeccanica Pompe India Branch", logo: "/images/client-placeholder.png" },
  { name: "Jampow Fabricators, Karad", logo: "/images/client-placeholder.png" },
  { name: "A.R. Wilfley India Pvt. Ltd.", logo: "/images/client-placeholder.png" },
  { name: "TUV Rheinland (India) Pvt. Ltd.", logo: "/images/client-placeholder.png" },
  { name: "Wilo Mather & Platt Pumps Pvt. Ltd.", logo: "/images/client-placeholder.png" },
  { name: "Trillium Flow Services India Pvt. Ltd.", logo: "/images/client-placeholder.png" },
  { name: "Sungov Engg. Pvt. Ltd.", logo: "/images/client-placeholder.png" },
  { name: "Smartserve LLC., Moscow", logo: "/images/client-placeholder.png" },
  { name: "Valvitalia Italy", logo: "/images/client-placeholder.png" },
  { name: "RMT Valvomeccanica, Italy", logo: "/images/client-placeholder.png" },
  { name: "Pibiviesse, Italy", logo: "/images/client-placeholder.png" },
  { name: "Xylem Water Solutions Pvt. Ltd.", logo: "/images/client-placeholder.png" },
  { name: "Fino Cast Pvt. Ltd.", logo: "/images/client-placeholder.png" },
  { name: "DYC Global Pvt. Ltd.", logo: "/images/client-placeholder.png" },
  { name: "ITT Corporation India Pvt. Ltd.", logo: "/images/client-placeholder.png" },
  { name: "Allweiler India Pvt. Ltd.", logo: "/images/client-placeholder.png" },
];

const Clients = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <section
        className="clients-hero-section"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL + "/images/hero1.jpg"})`,
        }}
      >
        <div className="overlay"></div>
        <div className="clients-hero-content" data-aos="fade-up">
          <h1>Our Clients</h1>
          <p>We are proud to work with these esteemed organizations</p>
        </div>
      </section>

      {/* Clients Grid */}
      <section className="clients-grid" data-aos="fade-up">
        {clients.map((client, index) => (
          <div className="client-card" key={index} data-aos="zoom-in" data-aos-delay={index * 50}>
            <div className="client-logo">
              <img src={process.env.PUBLIC_URL + client.logo} alt={client.name} />
            </div>
            <p>{client.name}</p>
          </div>
        ))}
      </section>
    </div>
  );
};

export default Clients;
